module.exports = __webpack_public_path__ + "static/media/riyansh.068bfee7.png";